<div [class]="modalSize" #modal>
  @if (!closable) {
    <div class="evs_modal_bg" #modalBg></div>
  }
  @if (closable) {
    <div class="evs_modal_bg" (click)="closeModal()" #modalBg></div>
  }
  <div class="evs_modal_container" #modalContainer>
    @if (closable) {
      <div class="evs_modal_close_btn display-block small-clickable" [class.no-title]="title == ''" (click)="closeModal()" #modalCloseBtn>
        <ion-icon name="close-outline"></ion-icon>
      </div>
    }
    @if (title != '') {
      <div class="evs_modal_header" #modalHeader>
        {{ title }}
      </div>
    }
    <div class="evs_modal_content" [class.large-content]="title != '' || isFooter" #modalContent>
      <ng-content></ng-content>
    </div>
    @if (isFooter) {
      <div class="evs_modal_footer" #modalFooter>
        <ion-button inline size="small" color="medium" class="margin-right-10" (click)="closeModal()">{{ footerText }}</ion-button>
      </div>
    }
  </div>
</div>
